/*
 * Copyright (c) 2026 上海安能聚创供应链管理有限公司. All rights reserved.
 * 公司内部代码，未经书面授权，不得以任何形式复制、传播或用于与安能无关的其他用途.
 */

/**
 * 分时段进出货量常量：运营日（12:00→次日 12:00）25 个时段，与后端
 * InOutVolumeTimeSlotConstant.SLOT_LABELS 顺序保持一致（勿单独调整其一）
 */
export const SLOT_LABELS = [
  '12:00-13:00',
  '13:00-15:00',
  '15:00-17:00',
  '17:00-19:00',
  '19:00-20:00',
  '20:00-21:00',
  '21:00-22:00',
  '22:00-23:00',
  '23:00-00:00',
  '00:00-01:00',
  '01:00-02:00',
  '02:00-03:00',
  '03:00-04:00',
  '04:00-04:30',
  '04:30-05:00',
  '05:00-05:30',
  '05:30-06:00',
  '06:00-06:30',
  '06:30-07:00',
  '07:00-07:30',
  '07:30-08:00',
  '08:00-08:30',
  '08:30-09:00',
  '09:00-11:00',
  '11:00-12:00',
];

/**
 * 合计列标签
 */
export const TOTAL_LABEL = '合计';

/**
 * 指标组定义：key 为行数据字段前缀，field 为后端响应 VO 字段名
 */
export const METRIC_GROUPS = [
  { key: 'escort', title: '押车货量', field: 'escortWeights' },
  { key: 'departure', title: '实际出发货量', field: 'actualDepartureWeights' },
  { key: 'arrival', title: '实际到达货量', field: 'actualArrivalWeights' },
];

/**
 * 计划指标组定义（事后分析图表 2）：key/field 语义同 METRIC_GROUPS
 */
export const PLAN_METRIC_GROUPS = [
  { key: 'planDeparture', title: '计划出发货量', field: 'planDepartureWeights' },
  { key: 'planArrival', title: '计划到达货量', field: 'planArrivalWeights' },
];
